export default __webpack_public_path__ + "lib/app-border.d3b862f2fdbcfde502946e19d69826bf.svg";